import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useObrasMaquinasEquipamentosViewModel } from "../../viewModels/obras_maquinasequipamentos_view_model";
import { GenerateControleColumnDefinition } from "./columns";
import { useMemo } from "react";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { ModalCreateObrasMaquinasEquipamentos } from "./components/modal_create";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ManutencaoEquipObraLista } from "../../../domain/models/manutencao_equip_obra_lista";
import { ObrasReportModals } from "../../components/obras_report_modals";

import DeleteDialog from "../../../../../common/components/delete_dialog";

export const Obrasmaquinasequipamentos = () => {
  const viewModel = useObrasMaquinasEquipamentosViewModel();

  const columnsDefinition = useMemo(() => {

    return GenerateControleColumnDefinition({
      onActionEditar: viewModel.handleManutencaoEquipObraCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteManutencaoEquipObraOpenState,
    });
  }, [
    viewModel.handleManutencaoEquipObraCadastroOpenState,
    viewModel.handleDeleteManutencaoEquipObraOpenState,
  ]);


  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra ?? null}
        onBack={viewModel.handleBack}
      ></ObrasTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link href="/Obras_lista" underline="hover" color="inherit">
            Lista de Obras
          </Link>
          <Typography className="text-primary-green">Lista de Máquinas e Equipamentos</Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title="Equipamentos Críticos"
            selectedObra={viewModel.selectedObra ?? null}
            onReload={viewModel.handleReload}
            onNewItem={() => { viewModel.handleManutencaoEquipObraCadastroOpenState(null, true); }}
          />

        </div>

        <Stack spacing={0}>
          <div className="w-full flex flex-row justify-between items-stretch">
            <div className="flex flex-col flex-wrap justify-end">
              <LegendComponent></LegendComponent>
            </div>

            <div className="flex flex-col justify-between flex-1">
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
              />
            </div>
          </div>

          <StyledDataGrid
            tableName="Obrasmaquinasequipamentos"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowHeight={() => 'auto'}
            textSize="muitoPequeno"
            getRowId={(row: ManutencaoEquipObraLista) => row.idManutencaoEquipObra}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.manutencaoEquipObraLista}
            rowCount={viewModel.manutencaoEquipObraLista.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ["idManutencaoEquipObra"],
            }}
          />

          <div className="flex flex-col justify-between flex-1">
            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </div>
        </Stack>
      </div>

      <ModalCreateObrasMaquinasEquipamentos
        open={viewModel.openCreateModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleManutencaoEquipObraCadastroOpenState(null, false)}
        onSubmit={viewModel.handleManutencaoEquipObraSubmit}
        selectedManutencaoEquipObra={viewModel.selectedManutencaoEquipObra}
      />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.handleDeleteManutencaoEquipObraOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteManutencaoEquipObraSubmit}
      />
    </>
  );
};
